export const blockIconsHardwareBookOnlineNew = (
	<span className='material-symbols-outlined'>book_online</span>
);
